import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import styles from "./KanbanCard.module.css";
/**
 * Card compartilhado do Kanban (Onda B, item B2).
 *
 * Estrutura visual única para qualquer board Kanban do produto — hoje o
 * pipeline comercial (`KanbanBoard`) e o pipeline de parcerias
 * (`PartnerKanbanBoard`). O conteúdo de cada domínio entra por slots
 * (`eyebrow`, `badge`, `highlight`, `metaStart`, `metaEnd`); o drag-and-drop
 * (posição, listeners, ref) é responsabilidade de quem consome — este
 * componente é puramente apresentacional, sem dependência de `@dnd-kit`.
 *
 * `data-kanban-card` é um marcador estável para teste: confirma que duas
 * telas usam o MESMO componente, não cópias visualmente parecidas.
 */
export const KanbanCard = forwardRef(function KanbanCard({ title, eyebrow, badge, highlight, metaStart, metaEnd, className, ...rest }, ref) {
    const hasTop = Boolean(eyebrow) || Boolean(badge);
    const hasMeta = Boolean(metaStart) || Boolean(metaEnd);
    return (_jsxs("div", { ref: ref, "data-kanban-card": "true", className: [styles.card, className].filter(Boolean).join(" "), ...rest, children: [hasTop && (_jsxs("div", { className: styles.top, children: [eyebrow && _jsx("div", { className: styles.identity, children: eyebrow }), badge] })), _jsx("span", { className: styles.name, children: title }), highlight && _jsx("span", { className: styles.highlight, children: highlight }), hasMeta && (_jsxs("div", { className: styles.meta, children: [metaStart, metaEnd] }))] }));
});
//# sourceMappingURL=KanbanCard.js.map